import axios from 'axios'

export type LocationGroupErrorKind =
  | 'duplicateName'
  | 'exists'
  | 'notFound'
  | 'invalid'
  | 'unauthorized'
  | 'forbidden'
  | 'server'
  | 'network'
  | 'unexpectedStatus'

export class LocationGroupRepositoryError extends Error {
  constructor(
    public readonly kind: LocationGroupErrorKind,
    public readonly status?: number,
    public readonly code?: string
  ) {
    super(kind)
    this.name = 'LocationGroupRepositoryError'
  }
}

const CODE_KINDS: Record<string, LocationGroupErrorKind> = {
  LOCATION_GROUP_NAME_DUPLICATE: 'duplicateName',
  LOCATION_GROUP_EXISTS: 'exists',
  NO_LOCATION_GROUP: 'notFound'
}

export function mapLocationGroupError(error: unknown): LocationGroupRepositoryError {
  if (error instanceof LocationGroupRepositoryError) return error
  if (!axios.isAxiosError(error) || !error.response) return new LocationGroupRepositoryError('network')

  const status = error.response.status
  const code = (error.response.data as { code?: string } | undefined)?.code
  const kind = (code && CODE_KINDS[code]) || statusKind(status)
  return new LocationGroupRepositoryError(kind, status, code)
}

export function errorFromResponse(status: number, data: unknown): LocationGroupRepositoryError {
  const code = (data as { code?: string } | undefined)?.code
  return new LocationGroupRepositoryError((code && CODE_KINDS[code]) || statusKind(status), status, code)
}

function statusKind(status: number): LocationGroupErrorKind {
  if (status === 400) return 'invalid'
  if (status === 401) return 'unauthorized'
  if (status === 403) return 'forbidden'
  if (status === 404) return 'notFound'
  if (status === 409) return 'exists'
  if (status >= 500) return 'server'
  return 'unexpectedStatus'
}
